import React from 'react'
import { Redirect, Route } from 'react-router-dom'

export const Rutaprivadadministrador = ({
   isAuthenticated,
   admin,
   component: Component,
   ...rest
}) => {
    return (
       <Route { ...rest }
            component={ (props) => (
                ( isAuthenticated && admin === 'Administrador')
                    ? <Component { ...props } />
                    : <Redirect to="/login" />
            )} 
        />
    )
}
